import './blob-inset.css';

export function attachBlobInset(stage) {
  if (!matchMedia("(hover: hover)").matches) return null;
  // Cast the fabric's shadow onto the art below it. The shell clips every
  // blurred pixel inside the aperture, so there is no raised outer rim.
  stage.querySelector('.project-global-shell').insertAdjacentHTML('beforeend', `
    <svg class="blob-inset" aria-hidden="true" focusable="false">
      <defs>
        <filter id="blob-inset-soft" x="-20%" y="-20%" width="140%" height="140%" color-interpolation-filters="sRGB">
          <feGaussianBlur stdDeviation="6"/>
          <feOffset dx="1" dy="4"/>
        </filter>
        <filter id="blob-inset-contact" x="-20%" y="-20%" width="140%" height="140%" color-interpolation-filters="sRGB">
          <feGaussianBlur stdDeviation="1.8"/>
          <feOffset dx="0.5" dy="1.3"/>
        </filter>
      </defs>
      <path class="blob-inset-soft" fill-rule="evenodd"/>
      <path class="blob-inset-contact" fill-rule="evenodd"/>
    </svg>`);
  const svg = stage.querySelector('.blob-inset');
  const paths = [...svg.querySelectorAll('[fill-rule]')];
  return (points, _state, rect, left, top, width, height) => {
    const hole = points.map((point, index) => `${index ? 'L' : 'M'}${(rect.left + point.x - left).toFixed(1)},${(rect.top + point.y - top).toFixed(1)}`).join(' ') + 'Z';
    const outside = `M-80,-80H${width + 80}V${height + 80}H-80Z`;
    svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
    paths.forEach(path => path.setAttribute('d', outside + hole));
  };
}
